<template>
  <div>
    <div v-if="importProcess">
      <div>
        <p>Quantidade arquivos: {{ importProcess.quantidadeArquivos }}</p>
      </div>
      <div>
        <p>Quantidade processados: {{ importProcess.quantidadeArquivosProcessados }}</p>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12">
          <b-progress :max="archivesTotal" height="2rem">
            <b-progress-bar
              style="color: black;"
              :value="archivesProcessed"
              :label="`${ Math.floor((archivesProcessed / archivesTotal) * 100) }%`"
              variant="success"
            ></b-progress-bar>
          </b-progress>
        </div>
      </div>
      <br />
      <div>
        <b-button
          type="submit"
          variant="primary"
          v-on:click="showDetails = !showDetails"
        >Exibir detalhes</b-button>
      </div>
      <div v-if="showDetails">
        <import-details :id="importacaoId" :lastRefresh="detailsLastRefresh"></import-details>
      </div>
    </div>
    <div v-else>
      <label>Importação não iniciada</label>
    </div>
  </div>
</template>

<script>
import CteImportDetails from "./CteImportDetails";

export default {
  name: "CTeImportStatus",
  components: {
    "import-details": CteImportDetails,
  },
  data: function () {
    return {
      id: null,
      detailsLastRefresh: null,
      importacaoId: null,
      importProcess: null,
      archivesTotal: 0,
      archivesProcessed: 0,
      showDetails: false,
      timer: null,
    };
  },
  beforeDestroy: function () {
    clearInterval(this.timer);
  },
  computed: {
    progressPercentage() {
      return Math.floor(this.archivesProcessed / this.archivesTotal) * 100;
    },
  },
  methods: {
    async initializeTimer(id) {
      this.id = id;
      this.loadImportProcess();
      this.timer = setInterval(this.loadImportProcess, 1000);
    },
    async finishProcess() {
      clearInterval(this.timer);
      this.loadImportProcess();
    },
    loadImportProcess() {
      if (this.id) {
        console.log("/cte/get/" + this.id.toString());
        this.$api
          .get("/cte/get/" + this.id.toString())
          .then((response) => {
            if (response) {
              this.importProcess = response.data.data;
              if (this.importProcess) {
                this.importacaoId = this.importProcess.id;

                if (this.importProcess) {
                  this.archivesTotal = this.importProcess.quantidadeArquivos;
                  this.archivesProcessed = this.importProcess.quantidadeArquivosProcessados;
                  this.$forceUpdate();
                  if (this.importProcess.dataFim) {
                    clearInterval(this.timer);
                  }
                }

                this.detailsLastRefresh = new Date();
              }
            }
          })
          .catch(function (error) {
            console.log(error);
            clearInterval(this.timer);
          });
      }
    },
  },
};
</script>